var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFuncaoSubstituir01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:none;stroke:#000000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2207",
    transform: "translate(-847.422 -828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder-2",
    transform: "translate(852.421 836.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1268",
    transform: "translate(0 18.988) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1267"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_755",
    d: "M12.2-0.8v-3.8l-5,5l5,5V1.8c2.8,0,5,2.2,5,5v2.5h2.5V6.8C19.8,2.6,16.4-0.7,12.2-0.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1269",
    transform: "translate(39.956 14.957) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1267-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_755-2",
    d: "M-1.7,13.2V9.4l-5,5l5,5v-3.8c2.8,0,5,2.2,5,5v2.5h2.5v-2.5C5.8,16.6,2.4,13.2-1.7,13.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_171",
    transform: "translate(20.579 -0.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -7.1,
    y: -4.9,
    className: "st0",
    width: 14.9,
    height: 10.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -6.6,
    y: -4.4,
    className: "st1",
    width: 14,
    height: 9.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_172",
    transform: "translate(19.946 33.947) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 9.1,
    className: "st0",
    width: 15.8,
    height: 10.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.4,
    y: 9.5,
    className: "st1",
    width: 14.9,
    height: 9.3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFuncaoSubstituir01);
export default __webpack_public_path__ + "static/media/ico-funcao-substituir-01.b78862dcdcff83233ba70d2f663cb516.svg";
export { ForwardRef as ReactComponent };